import { siteApiSlice } from "../../app/siteApiSlice";
import { WritingAction } from "../writing/writingApiSlice";

export interface DashboardViewModel {
	activeCourseCards: ActiveDashboardCardViewModel[];
	inactiveCourseCards: InactiveDashboardCardViewModel[];
}

export interface BaseDashboardCardViewModel {
	courseId: number;
	userCourseId: number;
	courseName: string;
	gradeId: number;
	teachers: string[];
}

export interface InactiveDashboardCardViewModel extends BaseDashboardCardViewModel {
	active: boolean;
	createDate: Date;
}

export interface ActiveDashboardCardViewModel extends BaseDashboardCardViewModel {
	isFavorite: boolean;
	topPeerReviews: DashboardPeerReviewViewModel[];
	topLessons: DashboardLessonViewModel[];
	topEssays: DashboardEssayViewModel[];
}

export interface DashboardPeerReviewViewModel {
	reviewId: number;
	promptTitle: string;
	author: string;
	requestDate: Date;
}

export interface DashboardLessonViewModel {
	lessonId: number;
	lessonTitle: string;
	codeName: string;
	isStarted: boolean;
	timeSpent: number;
	isAssignment: boolean;
}

export interface DashboardEssayViewModel {
	essayId: number;
	action: WritingAction;
	actionDraftId: number;
	promptId: number;
	promptTitle: string;
	dueDate: Date;
	step: string;
	numDrafts: number;
	newMessageCount: number;
	hasDueDate: boolean;
	isAssigned: boolean;
}

export const EmptyDashboardViewModel: DashboardViewModel = {
	activeCourseCards: [],
	inactiveCourseCards: [],
};

export const coursesApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		getDashboardInfo: build.query<DashboardViewModel, boolean>({
			query: (getInactive) => ({
				url: `/SignIn/GetDashboardInfo`,
				params: { getInactive },
			}),
			providesTags: ["CourseRegistrations", "LessonHistory", "PeerReview", "WritingHistory"],
		}),
	}),
});

export const { useGetDashboardInfoQuery } = coursesApiSlice;
